import { useState } from "react";
import Header from "../components/Header";
import FooterSection from "../components/FooterSection";
import OffcanvasMenu from "../components/OffcanvasMenu";
import SearchPopup from "../components/SearchPopup";
import MouseCursor from "../components/MouseCursor";
import Preloader from "../components/Preloader";
import BackToTop from "../components/BackToTop";
import LetsTalkSection from "../components/LetsTalkSection";

import usePreloader from "../hooks/usePreloader";

const Layout = ({ children }) => {
  const [isOffcanvasOpen, setIsOffcanvasOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  // ✅ Gọi hook preloader
  const { showPreloader } = usePreloader(2000);

  return (
    <div>
      {showPreloader && <Preloader />}
      <MouseCursor />
      <BackToTop />

      <OffcanvasMenu
        isOpen={isOffcanvasOpen}
        onClose={() => setIsOffcanvasOpen(false)}
      />
      <SearchPopup
        isOpen={isSearchOpen}
        onClose={() => setIsSearchOpen(false)}
      />

      <Header
        toggleOffcanvas={() => setIsOffcanvasOpen((prev) => !prev)}
        toggleSearch={() => setIsSearchOpen(true)}
      />

      <main>{children}</main>

      <LetsTalkSection />

      <FooterSection />
    </div>
  );
};

export default Layout;
